import apiService from "../../../services/api-client";

export interface StockProduct {
  snapshot_date: string;
  product_sku: string;
  product_name: string;
  supplier: string | null;
  warehouse: string;
  stock: number;
  cost: number;
  alert_days: number;
}

export interface StockProductsResponse {
  status: string;
  company_id: number;
  snapshot_date: string;
  total_products: number;
  total_units: number;
  total_value: number;
  products: StockProduct[];
  limit: number;
  offset: number;
  total: number;
  sort_order: string;
}

export interface StockFiltersResponse {
  status: string;
  company_id: number;
  filters: {
    warehouses: string[];
    suppliers: string[];
    skus: string[];
    products: string[];
  };
}

export interface StockProductsParams {
  limit?: number;
  offset?: number;
  sort_order?: 'desc' | 'asc';
  filter_product?: string;
  filter_sku?: string;
  filter_warehouse?: string;
  filter_supplier?: string;
}

export const stockConsultantApiService = {
  async getProducts(
    companyId: string,
    params?: StockProductsParams
  ): Promise<StockProductsResponse> {
    const { data } = await apiService().get<StockProductsResponse>(
      `/stock-consultant/${companyId}/products`,
      { params }
    );
    return data;
  },

  async getFilters(companyId: string): Promise<StockFiltersResponse> {
    const { data } = await apiService().get<StockFiltersResponse>(
      `/stock-consultant/${companyId}/filters`
    );
    return data;
  },
};
